/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';
import { CREDIT_REDEMPTION } from './types';

export function requestCreditRedemption(creditToken) {
  return {
    type: CREDIT_REDEMPTION,
    endpoint: `/orderapp/v1/credits/redemption_status?${queryString.stringify({
      status_token: creditToken,
    })}`,
    options: {
      method: 'GET',
    },
  };
}
